// Types
import Reducers from "app/types/Reducers";
// Actions
import { AppUiNotificationsActions } from "../AppUINotifications/AppUINotifications.slice";
// Messages
import Messages from "./CalendarEvents.messages";
// Utilities
import asyncThunkHandler from "app/utilities/AsyncThunkHandler";
import { $delete, $get, $patch, $post, $put } from 'app/utilities/HttpClient';

const _url:string = '/calendarEvents';

export const getCalendarEvents = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Get calendar events`,
  async (params) => {
    const response:Response = await $get(_url, params);
    return response.json();
  }
);

export const getCalendarEvent = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Get calendar event`,
  async (eventId:number) => {
    const response:Response = await $get(`${_url}/${eventId}`);
    return response.json();
  }
);

export const createCalendarEvent = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Create calendar event`,
  async (data:any, { dispatch }) => {
    const response:Response = await $post(_url, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Create
    }));
    return response.json();
  }
);

export const updateCalendarEvent = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Update calendar event`,
  async ({ eventId, data }:{ eventId:number, data:any }, { dispatch }) => {
    const response:Response = await $put(`${_url}/${eventId}`, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Update
    }));
    return response.json();
  }
);

export const patchCalendarEvent = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Patch calendar event`,
  async ({ eventId, data }:{ eventId:number, data:any }, { dispatch }) => {
    const response:Response = await $patch(`${_url}/${eventId}`, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Update
    }));
    return response.json();
  }
);

export const deleteCalendarEvent = asyncThunkHandler(
  `${Reducers.CalendarEvents}/Delete calendar event`,
  async (eventId:number, { fulfillWithValue, dispatch }) => {
    await $delete(`${_url}/${eventId}`);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Delete
    }));
    return fulfillWithValue(eventId);
  }
);
